/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockRecipeEditCtrl
 */
angular.module('mercury.modules.stock.recipe')
.controller('StockRecipeViewDialogCtrl', ["dialog", "$scope", "$q", "$window", "StockRecipes", "StockCost", "dialogData", function(dialog, $scope, $q, $window,
  StockRecipes, StockCost, dialogData) {

  $scope.recipeChanged = false;

  $scope.endDate = dialogData.endDate;
  $scope.cogsLoading = $q.defer();
  $scope.cogsLoadingPromise = $scope.cogsLoading.promise;

  /**
   * Helper to iterate over all lines in a recipe getting the COGs value for
   * each, then merges the data with the standard recipe lines and sets that
   * in the scope for template rendering.
   */
  function extendRecipeVersionLineWithCogsData(version) {
    var itemIdTimeStrings = [];
    var recipeIdTimeStrings = [];

    angular.forEach(version.lines, function(line) {
      if (line.itemId) itemIdTimeStrings.push(`${line.itemId},${dialogData.endDate}`);
      if (line.recipeId) recipeIdTimeStrings.push(`${line.recipeId},${dialogData.endDate}`);
    });

    // once all cogs calls have completed extend each current recipe line to
    // have the cogs data attached
    StockCost.get(itemIdTimeStrings, recipeIdTimeStrings)
      .then(function(result) {        
        var itemCostsById = result.itemCosts;
        var recipeCostsById = result.recipeCosts;

        angular.forEach(version.lines, function(line, idx) {
          // We know there will only be one item in the costById arrays (as we only use a single date to cost all items/recipes)
          var stockCost = line.itemId ? itemCostsById[line.itemId][0] : recipeCostsById[line.recipeId][0]
          
          version.lines[idx].cogsStockCost = stockCost.cost;
          version.lines[idx].cogsStockUnitName = stockCost.unitName;
          version.lines[idx].cogsStockUnitRatio = stockCost.unitRatio;
          version.lines[idx].cogsStockCostDocumentId = stockCost.documentId;
          version.lines[idx].cogsStockCostDocumentType = stockCost.documentType;
        })

        // with our newly decorated version set it for use in the template, and
        // release the cogs loading promise so the template will render
        $scope.version = version;
        $scope.cogsLoading.resolve();

      });
  }

  StockRecipes.getStockApi(dialogData.recipeId, dialogData.endDate)
    .then(function(result) {

      $scope.recipe = result;

      var activeVersionIndex = 0;

      if ($scope.recipe.versions.length > 1) {
        angular.forEach($scope.recipe.versions, function(version, versionIndex) {
          // We need to ensure the recipe version we select is the one active
          // at the end of the reporting period.
          if (
            version.validFrom === null ||
            moment(version.validFrom).isBefore(dialogData.endDate)
          ) {
            activeVersionIndex = versionIndex;
          }
        });
      }

      $scope.activeVersion = activeVersionIndex + 1;

      extendRecipeVersionLineWithCogsData(
        $scope.recipe.versions[activeVersionIndex]
      );

      var nextVersionIndex = activeVersionIndex + 1;
      if (result.versions[nextVersionIndex]) {
        $scope.validUntil = result.versions[nextVersionIndex].validFrom;
      }
    });

  $scope.print = function() {
    $window.print();
  };

  /**
   * Opens a dialog with the purchase order history for the selected item
   * in the recipe.
   *
   * @param {*} recipeLine
   */
  $scope.openPurchaseHistory = function(recipeLine) {
    dialog.open({
      backdrop: 'static',
      templateUrl: 'modules/reports/cogs/purchasehistory.tpl.html',
      controller: 'CogsPurchaseHistoryCtrl',
      size: 'lg',
      resolve: {
        dialogData: function() {
          return {
            recipeId: null,
            stockItemId: recipeLine.itemId,
            startDate: dialogData.startDate,
            endDate: dialogData.endDate,
            cogsStockCostDocumentId: recipeLine.cogsStockCostDocumentId,
            cogsStockCostDocumentType: recipeLine.cogsStockCostDocumentType
          };
        }
      }
    });
  };

  /**
   * Opens a dialog with the recipe view for the selected sub-recipe.
   *
   * @param {*} recipeLine
   */
  $scope.openSubRecipe = function(recipeLine) {
    dialog.open({
      backdrop: 'static',
      templateUrl: 'modules/stock/recipe/viewdialog.tpl.html',
      controller: 'StockRecipeViewDialogCtrl',
      size: 'lg',
      resolve: {
        dialogData: function() {
          return {
            recipeId: recipeLine.recipeId,
            stockItemId: null,
            startDate: dialogData.startDate,
            endDate: dialogData.endDate
          };
        }
      }
    }).then(function(dialogResult) {
      if (dialogResult.recipeChanged === true) {
        $scope.recipeChanged = true;
      }
    });
  };

  /**
   * Opens a dialog with the recipe editor for the selected recipe.
   *
   * @param {*} recipeId
   */
  $scope.openRecipeEditor = function(recipeId) {
    dialog.open({
      backdrop: 'static',
      templateUrl: 'modules/stock/recipe/edit.tpl.html',
      controller: 'StockRecipeEditCtrl',
      size: 'lg',
      resolve: {
        $stateParams: function() {
          return {
            id: recipeId,
            withinDialog: true
          };
        }
      }
    }).then(function(dialogResult) {
      if (dialogResult.recipeChanged === true) {
        $scope.recipeChanged = true;
      }
    });
  };

  /**
  * Check if any of the recipes lines in the displayed version has a deleted object
  *
  * @return {Boolean} If a deleted object exists, return true, otherwise false.
  */
  $scope.versionHasDeletedLines = function() {
    var result = false;
    if ($scope.version) {
      angular.forEach($scope.version.lines, function(line) {
        if (line.deletedAt) {
          result = true;
        }
      });
    }
    return result;
  };

  /*
  * Calculate the total cost of the recipe lines.
  *
  * @return {Number} The total cost
  */
  $scope.totalCost = function() {
    if (!$scope.version) {
      return 0;
    }

    var total = 0;
    angular.forEach($scope.version.lines, function(line) {
      if (line.quantity) {
        total += line.cogsStockCost * line.quantity;
      }
    });
    return total;
  };

  $scope.close = function() {
    dialog.close({recipeChanged: $scope.recipeChanged});
  };
}]);
